import { LazyAction, LazyModule } from 'owa-bundling';

const lazyModule = new LazyModule(
    () => import(/* webpackChunkName: "CalendarItemModal" */ './lazyIndex')
);

// Lazy-load actions
export let lazyHideItemDeleteModal = new LazyAction(lazyModule, m => m.hideItemDeleteModal);
export let lazyShowItemDeleteModal = new LazyAction(lazyModule, m => m.showItemDeleteModal);

export let lazyHideMeetingDndModal = new LazyAction(lazyModule, m => m.hideMeetingDndModal);
export let lazyShowMeetingDndModal = new LazyAction(lazyModule, m => m.showMeetingDndModal);

export { default as showItemDeleteModal } from './actions/showItemDeleteModal';
export { default as hideItemDeleteModal } from './actions/hideItemDeleteModal';
export { default as showMeetingDndModal } from './actions/showMeetingDndModal';
export { default as hideMeetingDndModal } from './actions/hideMeetingDndModal';
